//
// Module for rollover step content (partial view) displayed within common Rollover Step in Benefit Setup wizards
//
rs.module("participant/benefit/setup/common/wizard/rolloverstepcontent",

    ["controls/components/event-banner",
     "common/select-helper",
     "common/visibility"],

    function (eventBanner, selectHelper, visibility) {

        // Initialize the module
        function initialize(jsSelectors, variables, modes, codeValues, backendUrls) {

            // get JS selectors
            var stepContentContainer = $.js(jsSelectors.stepContentContainer);
            var addLink = stepContentContainer.js(jsSelectors.addLink, { required: false });
            var deleteLink = stepContentContainer.js(jsSelectors.deleteLink, { required: false, multiple: true });
            var saveButton = stepContentContainer.js(jsSelectors.saveButton, { required: false });
            var cancelButton = stepContentContainer.js(jsSelectors.cancelButton, { required: false });
            var addAgencyCheckBox = stepContentContainer.js(jsSelectors.addAgencyCheckBox, { required: false });
            var existingAgencySelect = stepContentContainer.js(jsSelectors.existingAgencySelect, { required: false });
            var existingAgencyMailToContainer = stepContentContainer.js(jsSelectors.existingAgencyMailToContainer, { required: false });
            var existingAgencyMailToInput = stepContentContainer.js(jsSelectors.existingAgencyMailToInput, { required: false });
            var existingAgencyAddressContainer = stepContentContainer.js(jsSelectors.existingAgencyAddressContainer, { required: false });
            var addAgencyContainer = stepContentContainer.js(jsSelectors.addAgencyContainer, { required: false });
            var addAgencyAddressTypeSelect = stepContentContainer.js(jsSelectors.addAgencyAddressTypeSelect, { required: false });
            var addAgencyCountrySelect = stepContentContainer.js(jsSelectors.addAgencyCountrySelect, { required: false });
            var enterManually = stepContentContainer.js(jsSelectors.enterManually, { required: false });
            var avasOverride = stepContentContainer.js(jsSelectors.avasOverride, { required: false });
            var avasOverrideHidden = stepContentContainer.js(jsSelectors.avasOverrideHidden, { required: false });

            // Get the form (this will be the wizard form)
            var _form = stepContentContainer.closest("form");

            // Reset validation
            $.validator.resetValidation(_form);

            // Get the wizard's next and back buttons for enabling/disabling 
            var wizardNextButton = $(`[data-wizard]`).js("_next");
            var wizardBackButton = $(`[data-wizard]`).js("_back");
  
            // addLink click handler
            addLink.on("click", function (event) {

                // prevent the button from causing a post
                event.preventDefault();

                // clear any messages in the message banner
                eventBanner.removeAllMessages();

                $.get(backendUrls.getRolloverStepContent,
                    {
                        benefitClaimKey: variables.benefitClaimKey,
                        benefitClaimPaymentKey: variables.benefitClaimPaymentKey,
                        mode: modes.add
                    })
                    .done(function (html) {
                        stepContentContainer.parent().html(html);
                        wizardNextButton.setDisabled();
                        wizardBackButton.setDisabled();
                    });
            });

            // deleteLink click handler
            deleteLink.on("click", function (event) {

                // prevent the button from causing a post
                event.preventDefault();

                // clear any messages in the message banner
                eventBanner.removeAllMessages();

                // get key of rollover record to delete
                var rolloverKey = $(this).data("rolloverkey");

                $.post(
                    backendUrls.deleteRollover,
                    {
                        rolloverKey: rolloverKey,
                        benefitClaimKey: variables.benefitClaimKey,
                        benefitClaimPaymentKey: variables.benefitClaimPaymentKey
                    }
                ).done(function (html) {

                    // Populate the parent container with the returned partial view
                    stepContentContainer.parent().html(html);
                });
            });

            // cancelButton click handler
            cancelButton.on("click", function (event) {

                // prevent the button from causing a post
                event.preventDefault();

                // clear any messages in the message banner
                eventBanner.removeAllMessages();

                $.get(backendUrls.getRolloverStepContent,
                    {
                        benefitClaimKey: variables.benefitClaimKey,
                        benefitClaimPaymentKey: variables.benefitClaimPaymentKey,
                        mode: modes.view
                    })
                    .done(function (html) {
                        stepContentContainer.parent().html(html);
                        wizardNextButton.setDisabled(false);
                        wizardBackButton.setDisabled(false);
                    });
            });

            // saveButton click handler
            saveButton.on("click", function (event) {

                // prevent the button from causing a post
                event.preventDefault();

                // clear any messages in the message banner
                eventBanner.removeAllMessages();

                if (_form.valid()) {
                    $.post(                        
                        {
                            url: backendUrls.saveRollover,
                            data: new FormData(_form[0]),
                            contentType: false,
                            cache: false,
                            processData:false
                        }
                    ).done(function (html, status, xhr) {

                        // Populate the parent container with the returned partial view
                        stepContentContainer.parent().html(html);

                        // If successful, re-enable wizard buttons
                        if (xhr.rsMessages == null || (xhr.rsMessages != null && xhr.rsMessages.ModelStateErrors.length == 0)) {
                            wizardNextButton.setDisabled(false);
                            wizardBackButton.setDisabled(false);
                        }
                    });
                }
            });

            // existingAgencySelect change event
            existingAgencySelect.change(function () {

                existingAgencySelect.clearErrors();

                // repopulate agency address
                $.get(backendUrls.getAgencyAddress,
                    {
                        rolloverAgencyKey: this.value
                    })
                    .done(function (result) {
                        existingAgencyAddressContainer.html(result);
                    });

                // repopulate agency mail to
                if (this.value) {
                    $.get(backendUrls.getAgencyMailTo,
                        {
                            rolloverAgencyKey: this.value
                        })
                        .done(function (result) {
                            existingAgencyMailToInput.val(result.mailTo).clearErrors();
                        });
                }
                else {
                    existingAgencyMailToInput.val('').clearErrors();
                }            
            });

            // addAgencyCheckBox change event
            addAgencyCheckBox.change(function () {

                var addAgencyChecked = addAgencyCheckBox.is(":checked");

                // get select helpers
                var existingAgencySelectHelper = selectHelper.getHelper(existingAgencySelect);
                var addAgencyAddressTypeSelectHelper = selectHelper.getHelper(addAgencyAddressTypeSelect);
                var addAgencyCountrySelectHelper = selectHelper.getHelper(addAgencyCountrySelect);

                if (addAgencyChecked) {

                    existingAgencySelectHelper.setValue('').setDisabled(true);
                    existingAgencySelect.clearErrors();
                    existingAgencyAddressContainer.html('');
                    existingAgencyMailToInput.val('');
                }
                else {
                    existingAgencySelectHelper.setDisabled(false);

                    clearInputs(addAgencyContainer);

                    addAgencyAddressTypeSelectHelper.setValue(codeValues.main.toString());
                    addAgencyCountrySelectHelper.setValue(codeValues.usa.toString());
                }

                visibility.setVisible(existingAgencyMailToContainer, !addAgencyChecked);
                visibility.setVisible(addAgencyContainer, addAgencyChecked);
            });

            //clear all inputs and selects within the supplied container
            function clearInputs(container) {
                container.find(":input").not(avasOverride).not(avasOverrideHidden).not(enterManually).val('');
                container.find("select").each(function () { selectHelper.getHelper($(this)).setValue(''); });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);